import { Button, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { sendSingleRequest } from '../../apis';
import { Title } from '../../components/shared';
import { selectIsAdmin } from '../../store/auth/auth.selector';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';

interface IInvite {
  email: string;
  role: string;
  register_url: string;
}

const InvitedUsers = () => {
  const lang = useSelector(selectLang);
  const isAdmin = useSelector(selectIsAdmin);

  const [invites, setInvites] = useState<IInvite[]>();
  const [disabled, setDisabled] = useState(false);

  const deleteInvite = async (email: string) => {
    if (
      !window.confirm(
        translate(lang, 'Are you sure you want to delete this invite?'),
      )
    )
      return;

    setDisabled(true);
    const res = await sendSingleRequest(
      { email },
      'DELETE',
      'api/user/owner-pending-user',
      true,
    );
    setDisabled(false);
    if (res.status) {
      setInvites(invites?.filter(x => x.email !== email));
    } else {
      window.alert(
        translate(lang, res.data?.message ?? 'Failed to delete the invite.'),
      );
    }
  };

  const columns = [
    {
      key: 'email',
      title: 'Email',
      render: (x: IInvite) => <span>{x.email}</span>,
    },
    {
      key: 'role',
      title: 'Role',
      render: (x: IInvite) => <span>{x.role}</span>,
    },
    {
      key: 'url',
      title: 'Active link',
      render: (x: IInvite) => <span>{x.register_url}</span>,
    },
    {
      key: 'btn',
      title: '',
      render: (x: IInvite) => (
        <div className='d-flex gap-12'>
          <Button
            type='primary'
            color='blue'
            size='small'
            onClick={() => {
              navigator.clipboard.writeText(x.register_url);
              alert('Sing up link is copied');
            }}
            disabled={disabled}
          >
            {translate(lang, 'Copy')}
          </Button>
          <Button
            type='primary'
            size='small'
            danger={true}
            onClick={() => deleteInvite(x.email)}
            disabled={disabled}
          >
            {translate(lang, 'Delete')}
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const loadInvites = async () => {
      const res = await sendSingleRequest(
        {},
        'GET',
        'api/user/owner-pending-users',
        true,
      );
      if (res.status) setInvites(res.data);
    };
    if (isAdmin) {
      loadInvites();
    }
  }, [isAdmin]);

  return isAdmin ? (
    <div className='container'>
      <div className='users d-flex align-center'>
        <Title size={5} color='black' align='default' fontWeight={700}>
          {translate(lang, '_pending_invited_users')}
        </Title>
      </div>
      <div className='mb-17'>
        <Table
          rowKey={'email'}
          className='table table--isFarm'
          pagination={false}
          columns={columns.map(x => ({
            ...x,
            title: translate(lang, x.title),
          }))}
          dataSource={invites}
        />
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default InvitedUsers;
